<section class="drawerContainer drawerContainer-{{size}} {{drawerContainerClasses}} drawer-{{drawerType}}"
  [@SlideDirection]="drawerType === 'side'?'left':'up'">
  @if(isMobile){
  <button type="button"
    class="tw-h-10 tw-w-10 tw-text-center tw-leading-10 tw-bg-white tw-rounded-full tw-shadow-md tw-absolute tw-top-0 tw-right-4 -tw-translate-y-12 tw-z-10"
    (click)="closeDrawer()">
    <i-icon [name]="'x-mark'" [height]="'tw-h-4'" [width]="'tw-w-4'" class="!tw-block tw-m-auto"></i-icon>
  </button>
  }
  <div class="drawer_main">
    <ng-content select="[subHeader]"></ng-content>
    <div class="drawerContainer__main {{drawerConatinerMain}}">
      <div class="drawerContainer__header" *ngIf="headerContent">
        <ng-content select="[header]"></ng-content>
      </div>
      <div class="drawerContainer__body !{{bodyClass}}" *ngIf="bodyContent">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>
    <div class="drawerContainer__footer" *ngIf="footerContent">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</section>